<template>
    <div class="right_box_main">
        <!-- 面包屑导航 -->
        <!-- <div class="mianbao">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/griddingindex' }">网格工作</el-breadcrumb-item>
                <el-breadcrumb-item>网格巡查</el-breadcrumb-item>
                <el-breadcrumb-item>巡查分配</el-breadcrumb-item>
            </el-breadcrumb>
        </div> -->
        <div class="card-box">
            <!-- 右边卡片 -->
            <div class="card-rb">
                <div class="card-4">
                    <el-card :body-style="{ padding: '16px' }">
                        <div class="fisthang">
                            <el-form
                                :inline="true"
                                :model="searchlist"
                                class="demo-form-inline"
                                size="mini"
                            >
                                <el-form-item label="分配名称:">
                                    <el-input
                                        v-model="searchlist.name"
                                        placeholder="请输入分配名称"
                                        style="width: 200px"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item label="所属区域:">
                                    <el-cascader
                                        v-model="searchlist.orgId"
                                        :options="orgList"
                                        @change="handleChange"
                                        :show-all-levels="false"
                                    ></el-cascader>
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                        type="primary"
                                        @click="searchlistdata"
                                        >查询</el-button
                                    >
                                </el-form-item>
                                <el-form-item>
                                    <el-button
                                        type="info"
                                        @click="searchlistReset"
                                        >重置</el-button
                                    >
                                </el-form-item>
                            </el-form>
                        </div>
                        <div class="three">
                            <el-button
                                type="primary"
                                size="mini"
                                class="mb16"
                                @click="showDialogForm('', 'add')"
                                >新增</el-button
                            >
                        </div>
                        <!-- 表格盒子 -->
                        <div class="table_card">
                            <el-table
                                :data="tableData"
                                :header-cell-style="{ background: '#f8fafa' }"
                                border
                                align="center"
                            >
                                <!-- <el-table :data="tableData" :header-cell-style="{ background: '#f8fafa' }"
                                border align="center" @row-click="changeColor" :row-style="selectedHighlight" >-->
                                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                                <el-table-column
                                    type="index"
                                    align="center"
                                    label="序号"
                                    width="50"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="id"
                                    label="分配编号"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="name"
                                    label="分配名称"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="content"
                                    label="分配内容"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="orgIdCn"
                                    label="所属机构"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="userIdCn"
                                    label="巡查人员"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="times"
                                    label="添加时间"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>

                                <el-table-column
                                    align="center"
                                    prop="starttime"
                                    label="任务开始时间"
                                    width="150"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="endtime"
                                    label="任务结束时间"
                                    width="150"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>

                                <el-table-column
                                    align="center"
                                    prop="status"
                                    label="状态"
                                    :formatter="formatter"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column align="center" label="操作">
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="查看"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-chakan tabBtn"
                                                @click="
                                                    showDialogForm(
                                                        scope.row.id,
                                                        'detail'
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            v-if="!(scope.row.status == 1)"
                                            class="item"
                                            effect="light"
                                            content="修改"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-bianji3 tabBtn"
                                                @click="
                                                    showDialogForm(
                                                        scope.row.id,
                                                        'edit'
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            v-if="!(scope.row.status == 1)"
                                            class="item"
                                            effect="light"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <button
                                                class="iconfont icon-icon7 tabBtn"
                                                @click="
                                                    showdeletepanduan(
                                                        scope.row.id
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="生成"
                                            placement="top-start"
                                        >
                                            <button
                                                class="el-icon-document tabBtn"
                                                @click="scList(scope.row.id)"
                                            ></button>
                                        </el-tooltip>
                                        <!-- <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="启用"
                                            placement="top-start"
                                        >
                                            <button
                                                v-show="scope.row.status == 0"
                                                class="el-icon-success tabBtn"
                                                @click="statusChange(scope.row.id,'open')"
                                            ></button>
                                        </el-tooltip> -->
                                        <!-- <el-tooltip
                                            class="item"
                                            effect="light"
                                            content="停用"
                                            placement="top-start"
                                        >
                                            <button
                                                v-show="scope.row.status != 0"
                                                class="el-icon-error tabBtn"
                                                @click="statusChange(scope.row.id,'close')"
                                            ></button>
                                        </el-tooltip> -->
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-pagination
                                :page-size="pageConfig.pageSize"
                                layout="total, prev, pager, next, jumper"
                                @current-change="handleCurrentChange"
                                :total="pageConfig.total"
                            ></el-pagination>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
        <!-- 弹出框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="showadd"
            width="85%"
            :before-close="clearadddata"
        >
            <el-form
                ref="baseForm"
                :rules="rules"
                :model="baseForm"
                label-width="110px"
                size="mini"
            >
                <el-form-item label="分配名称：" prop="name">
                    <el-input
                        :disabled="editDisable"
                        v-model="baseForm.name"
                        placeholder="请输入分配名称"
                        style="width: 50%"
                    ></el-input>
                </el-form-item>
                <el-form-item label="分配内容：" prop="content">
                    <el-input
                        type="textarea"
                        v-model="baseForm.content"
                        style="width: 50%"
                        :disabled="editDisable"
                    ></el-input>
                </el-form-item>
                <el-form-item label="机构/部门：" style="height: 40px">
                    <el-radio-group
                        :disabled="editDisable"
                        v-model="orgForm.radio"
                        @change="changOrgForm"
                    >
                        <el-radio label="1">机构用户</el-radio>
                        <el-radio label="2">部门用户</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    label="所属机构："
                    prop="releaseDate"
                    v-if="orgForm.radio == '1'"
                >
                    <el-cascader
                        v-model="baseForm.orgId"
                        :options="orgData1"
                        @change="handleChange1"
                        :show-all-levels="false"
                        :key="1"
                    ></el-cascader>
                </el-form-item>
                <el-form-item
                    label="所属部门："
                    prop="releaseDate"
                    v-if="orgForm.radio == '2'"
                >
                    <el-cascader
                        v-model="baseForm.orgId"
                        :options="orgData2"
                        @change="handleChange1"
                        :show-all-levels="false"
                        :key="2"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="选择用户：" prop="releaseDate">
                    <el-select
                        v-model="baseForm.userId"
                        placeholder="请选择用户"
                        :disabled="editDisable"
                    >
                        <el-option
                            v-for="item in userOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择路线" prop>
                    <div class="check">
                        <el-checkbox-group
                            @change="check"
                            v-model="checkList"
                            :disabled="editDisable"
                        >
                            <el-checkbox
                                :label="item.id"
                                v-for="item in jgList"
                                :key="item.id"
                                >{{ item.name }}</el-checkbox
                            >
                        </el-checkbox-group>
                    </div>
                </el-form-item>
                <el-form-item label="已选路线" prop v-model="checkList">
                    <div class="check">
                        <p v-for="item in haveList" :key="item.id">
                            {{ item.name }} ：{{ item.place }}
                        </p>
                    </div>
                </el-form-item>
                <el-form-item label="分配地图：" prop="addressDetail">
                    <div
                        id="mapDome"
                        style="width: 100%; height: 400px; margin-top: 10px"
                        :disabled="editDisable"
                    ></div>
                </el-form-item>
            </el-form>
            <div class="boontbtn">
                <el-button
                    v-if="showSaveBtn"
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveadddata"
                    >保存</el-button
                >
                <el-button type="info" size="small" @click="showadd = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
        <el-dialog title="生成" :visible.sync="showsc" width="60%">
            <el-form
                ref
                :rules="rules"
                :model="scForm"
                label-width="110px"
                size="mini"
            >
                <el-form-item label="巡视名称：" prop="name">
                    <el-input
                        :disabled="editDisable"
                        v-model="scForm.name"
                        placeholder="请输入巡视名称"
                        style="width: 50%"
                    ></el-input>
                </el-form-item>
                <el-form-item label="巡视内容：" prop="content">
                    <el-input
                        type="textarea"
                        v-model="scForm.content"
                        style="width: 50%"
                        :disabled="editDisable"
                    ></el-input>
                </el-form-item>
                <el-form-item label="开始时间：" prop="starttime">
                    <el-date-picker
                        v-model="scForm.starttime"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间：" prop="endtime">
                    <el-date-picker
                        v-model="scForm.endtime"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="时段设置：">
                    <el-time-select
                        placeholder="起始时间"
                        v-model="scForm.starttimeS"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '24:00',
                        }"
                    ></el-time-select
                    >-
                    <el-time-select
                        placeholder="结束时间"
                        v-model="scForm.endtimeS"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '24:00',
                        }"
                    ></el-time-select>
                    <el-button
                        type="primary"
                        icon="el-icon-plus"
                        @click="addDomain"
                        style="margin-left: 20px"
                    ></el-button>
                </el-form-item>
                <el-form-item
                    v-for="(domain, index) in domains"
                    :key="index"
                    label="时段设置："
                >
                    <el-time-select
                        placeholder="起始时间"
                        v-model="scForm['starttimeS' + index]"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '24:00',
                        }"
                    ></el-time-select
                    >-
                    <el-time-select
                        placeholder="结束时间"
                        v-model="scForm['endtimeS' + index]"
                        :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '24:00',
                        }"
                    ></el-time-select>
                    <el-button
                        type="danger"
                        icon="el-icon-delete"
                        @click.prevent="removeDomain(domain)"
                        style="margin-left: 20px"
                    ></el-button>
                </el-form-item>
            </el-form>
            <div class="boontbtn">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="submitsc"
                    >生成</el-button
                >
                <el-button type="info" size="small" @click="showsc = false"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { post, get } from "@/api/requrestHttp.js"
import editor_option from "../../../utils/editorOption.js"
import request from "../../../utils/request.js"
import { changeInfor } from "@/api/api"
import AMap from "AMap" // 引入高德地图
export default {
    data() {
        return {
            domains: [],
            showsc: false,
            scForm: {},
            taskIds: "",
            userOptions: [],
            markerList: [],
            haveList: [],
            checkList: [],
            jgList: [],
            orgList: [],
            dialogTitle: "新增",
            // 新增弹出层
            flag: "add",
            showadd: false,
            editDisable: false,
            showSaveBtn: true,
            baseForm: {
                userId: "",
            },

            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入分配名称",
                        trigger: "blur",
                    },
                ],
                policyConsultationType: [
                    {
                        required: true,
                        message: "请选择咨询类别",
                        trigger: "blur",
                    },
                ],
                advisoryName: [
                    {
                        required: true,
                        message: "请输入咨询标题",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入咨询内容",
                        trigger: "blur",
                    },
                ],
                releaseDate: [
                    {
                        required: true,
                        message: "请选择发布时间",
                        trigger: "blur",
                    },
                ],
                status: [
                    {
                        required: true,
                        message: "请选择发布状态",
                        trigger: "blur",
                    },
                ],
            },
            // 查询
            queryTime: [],
            searchlist: {},
            tableData: [],
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
            status: true,
            activityAddress: {},
            baseForm: {},
            option4: [],
            option5: [],
            option6: [],
            mapcontainer: "",
            orgForm: {
                radio: "1",
            },
            orgData2: [],
            orgData1: [],
            isok: true,
        }
    },
    created() {
        post("/rbac/admin/org/info/OrgTreelist", { isValid: 1 }).then((res) => {
            this.orgList = res.content
            for (let i in res.content) {
                if (res.content[i].orgType == "2") {
                    this.orgData2.push(res.content[i])
                } else {
                    this.orgData1.push(res.content[i])
                }
            }
        })
    },
    methods: {
        changOrgForm(val) {
            this.jgList = []
        },
        //生成
        submitsc() {
            if (!this.isok) return
            this.isok = false
            if (this.domains.length != 0) {
                this.scForm.index = this.domains.length - 1
            } else {
                this.scForm.index = ""
            }
            let data = changeInfor(this.scForm)
            post(
                "/admin/inspectionRecord/info/produceInspectionRecord",
                data
            ).then((res) => {
                this.$message.success(res.message)
                this.showsc = false
                if (res.code == 200) {
                    this.getPageDatas()
                }
                setTimeout(() => {
                    this.isok = true
                }, 200)
            })
        },
        //加时间段
        addDomain() {
            this.domains.push({
                value: "",
            })
        },
        //删除时间段
        removeDomain(item) {
            var index = this.domains.indexOf(item)
            if (index !== -1) {
                this.domains.splice(index, 1)
            }
        },
        //点击生成按钮
        scList(id) {
            console.log("111")
            this.showsc = true
            post("/admin/inspection/info/getInspection", { id: id }).then(
                (res) => {
                    this.scForm = res.content
                }
            )
        },
        async getTaskInform(val) {
            var _this = this
            let fc = async function (id) {
                let res = await post("/admin/task/info/getTask", { id })
                let obj = {}
                obj.id = res.content.id
                obj.name = res.content.name
                obj.place = res.content.place
                //已选任务
                _this.haveList.push(obj)
                //显示地图坐标
                let latitude = res.content.latitude
                let longitude = res.content.longitude
                return [longitude, latitude]
            }
            if (val) {
                //this.mapcontainer.remove(this.mapmarker);

                this.haveList = []
                this.markerList = []
                this.jwList = []
                val.map((item, index) => {
                    if (item == "") {
                        val.splice(index, 1)
                    }
                })
                this.jwList = await Promise.all(
                    val.map(async (item) => {
                        // 等待异步操作完成，返回执行结果
                        return await fc(item)
                    })
                )
                //console.log(this.jwList);
                //console.log(this.jwList.length);
                if (this.jwList.length >= 2) {
                    var walking = new AMap.Walking({})
                    //console.log(this.jwList);
                    for (let i = 0; i < this.jwList.length; i++) {
                        walking.search(
                            _this.jwList[i],
                            _this.jwList[i + 1],
                            function (status, result) {
                                // result即是对应的步行路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkingResult
                                if (status === "complete") {
                                    if (result.routes && result.routes.length) {
                                        var path = _this.parseRouteToPath(
                                            result.routes[0]
                                        )
                                        var startMarker = new AMap.Marker({
                                            position: path[0],
                                            // icon:
                                            //   "https://webapi.amap.com/theme/v1.3/markers/n/start.png",
                                            map: _this.mapcontainer,
                                        })

                                        var endMarker = new AMap.Marker({
                                            position: path[path.length - 1],
                                            // icon:
                                            //   "https://webapi.amap.com/theme/v1.3/markers/n/end.png",
                                            map: _this.mapcontainer,
                                        })

                                        var routeLine = new AMap.Polyline({
                                            path: path,
                                            isOutline: true,
                                            outlineColor: "#ffeeee",
                                            borderWeight: 2,
                                            strokeWeight: 5,
                                            strokeColor: "#0091ff",
                                            lineJoin: "round",
                                        })

                                        routeLine.setMap(_this.mapcontainer)
                                        _this.mapcontainer.setFitView()
                                        log.success("绘制步行路线完成")
                                    }
                                } else {
                                    log.error("步行路线数据查询失败" + result)
                                }
                            }
                        )
                    }
                } else {
                    this.mapmarker = new AMap.Marker({
                        position: _this.jwList[0],
                        map: _this.mapcontainer,
                    })
                    _this.mapcontainer.setFitView()
                }
            }
        },
        async check(val) {
            var _this = this
            //console.log(val,'==============路线id') //路线id
            let ids = []
            //传入的id数组长度不等于0 就继续执行
            //做这个判断 是因为取消选择路线也会触发次函数
            if (val.length != 0) {
                val.forEach((ele, index) => {
                    ids.push(ele)
                    this.getTaskList(ele)
                    //console.log(ele)
                })
                this.baseForm.wayId = ""
                this.baseForm.wayId = ids.toString()
                //console.log(this.baseForm.wayId);
                setTimeout((_) => {
                    let task = this.taskIds.slice().split(",")
                    //console.log(task);
                    this.mapcontainer.clearMap()
                    this.getTaskInform(task, "我是check执行的")
                }, 800)
            } else {
                this.haveList = []
                this.baseForm.wayId = ""
                this.mapcontainer.clearMap()
            }
        },

        parseRouteToPath(route) {
            var path = []

            for (var i = 0, l = route.steps.length; i < l; i++) {
                var step = route.steps[i]

                for (var j = 0, n = step.path.length; j < n; j++) {
                    path.push(step.path[j])
                }
            }

            return path
        },
        statusChange(id, flag) {
            this.$confirm("此操作将修改状态, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(async () => {
                let status = ""
                if (flag == "open") {
                    status = "1"
                } else {
                    status = "0"
                }
                post("/admin/inspection/info/updateInspection", {
                    id: id,
                    status: status,
                }).then((res) => {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    })
                    this.getPageDatas()
                })
            })
        },
        formatter(val) {
            // if (val.status == 0) {
            //     return "禁用";
            // } else {
            //     return "启用";
            // }
            if (val.status == 1) {
                return "已生成"
            } else {
                return "未生成"
            }
        },
        handleChange(value) {
            if (value != null) {
                //console.log(value);
                this.searchlist.orgId = value[value.length - 1]
            }
        },
        //获取路线
        async getWayList() {
            this.jgList = []
            await post("/admin/way/info/findWayList", {
                orgId: this.baseForm.orgId,
                pageNo: 1,
                pageSize: 99,
            }).then((res) => {
                //console.log(">>>",res);
                this.jgList = res.content.list
            })
        },
        //获取人员列表
        async getPersonList() {
            this.userOptions = []
            await post("/admin/user/info/list", {
                // orgId: this.baseForm.orgId[this.baseForm.orgId.length - 1],
                orgId: this.baseForm.orgId,
                pageNo: 1,
                pageSize: 99,
            }).then((res) => {
                res.content.list.forEach((e) => {
                    this.userOptions.push({
                        value: e.id,
                        label: e.name,
                    })
                })
            })
        },
        handleChange1(value) {
            if (value != null) {
                this.baseForm.orgId = value[value.length - 1]
                this.getWayList()
                //获取人员
                this.getPersonList()
                this.$nextTick((res) => {
                    this.baseForm.userId = ""
                })
            }
        },
        //条件查询
        searchlistdata() {
            this.pageConfig = {
                pageSize: 10,
                pageNo: 1,
            }
            this.getPageDatas()
        },
        searchlistReset() {
            this.searchlist = {}
            this.pageConfig = {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            }
            this.getPageDatas()
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            if (this.queryTime.length > 0) {
                this.searchlist.startTime = this.queryTime[0]
                this.searchlist.overTime = this.queryTime[1]
            }
            var res = await request({
                url: "/admin/inspection/info/findInspectionList",
                method: "POST",
                data: {
                    ...this.searchlist,
                    ...this.pageConfig,
                },
            })
            if (res.code == 200) {
                this.pageConfig.total = res.content.count
                this.tableData = res.content.list
                this.tableData.map(async (item, index) => {
                    if (item.status != null && item.status != 0) {
                        var res = await request({
                            url: "admin/inspectionRecord/info/findById",
                            method: "POST",
                            data: { inspectionId: item.id, pageSize: 10 },
                        })
                        this.$set(item, "starttime", res.content.startTime)
                        this.$set(item, "endtime", res.content.endTime)
                    }
                })
            } else {
                this.$message({
                    message: "数据加载异常：",
                    type: "error",
                })
            }
        },
        //获取taskid
        async getTaskList(element) {
            this.taskIds = ""
            let res = await post("/admin/way/info/getWayList", {
                id: element,
            })
            if (res.code == 200) {
                this.taskIds += ","
                this.taskIds += res.content.taskId
            }
        },
        async showDialogForm(id, flag) {
            this.flag = flag

            if (id != "") {
                if (flag == "detail") {
                    this.editDisable = true
                    this.showSaveBtn = false
                    this.dialogTitle = "查看"
                } else {
                    this.editDisable = false
                    this.showSaveBtn = true
                    this.dialogTitle = "编辑"
                }

                //获取编辑项的最新数据
                let data = {}
                data.id = id
                var res = await request({
                    url: "/admin/inspection/info/getInspection",
                    method: "POST",
                    data: data,
                })
                if (res.code == 200) {
                    this.baseForm = res.content
                    this.baseForm.orgId = res.content.orgId + ""
                    this.getPersonList()
                    this.baseForm.userId = Number(res.content.userId)
                    this.getWayList()
                    let ids = ""
                    if (res.content.wayId) {
                        ids = res.content.wayId.split(",").map(Number)
                    }
                    this.checkList = ids
                    //console.log(this.checkList);
                    if (ids) {
                        ids.forEach((element) => {
                            this.getTaskList(element)
                        })
                        setTimeout((_) => {
                            let task = null
                            if (this.taskIds) {
                                task = this.taskIds.slice(1).split(",")
                            }
                            this.getTaskInform(task, "我是showDialogForm执行的")
                        }, 800)
                    }

                    this.showadd = true
                } else {
                    this.$message({
                        message: "数据项加载异常",
                        type: "error",
                    })
                    this.showadd = false
                }
                this.$nextTick(() => {
                    this.mapInit("mapDome")
                })
            } else {
                this.editDisable = false
                this.showSaveBtn = true
                this.showadd = true
                this.dialogTitle = "新增"
                this.baseForm = {
                    userId: "",
                }
                this.fileList = []
                this.$nextTick(() => {
                    this.mapInit("mapDome")
                })
            }
        },

        //获取新增所有数据发请求
        async saveadddata() {
            let url = "/admin/inspection/info/updateInspection"
            if (this.flag == "add") {
                url = "/admin/inspection/info/insertInspection"
            }
            if (this.baseForm.name == undefined) {
                this.$message({
                    message: "请输入分配名称后,再提交!",
                    type: "error",
                })
                return
            } else if (this.baseForm.content == undefined) {
                this.$message({
                    message: "请输入分配内容后,再提交!",
                    type: "error",
                })
                return
            } else if (this.baseForm.orgId == undefined) {
                this.$message({
                    message: "请选择所属机构后,再提交!",
                    type: "error",
                })
                return
            } else if (this.baseForm.userId == "") {
                this.$message({
                    message: "请选择用户后,再提交!",
                    type: "error",
                })
                return
            }

            var res = await request({
                url: url,
                method: "POST",
                data: {
                    ...this.baseForm,
                },
            })
            if (res.code == 200) {
                this.$message({
                    message: this.dialogTitle + "成功",
                    type: "success",
                })
                this.showadd = false
                this.getPageDatas()
            } else {
                this.$message({
                    message: this.dialogTitle + "失败：" + res.message,
                    type: "error",
                })
            }
        },
        // 新增弹出框重置
        clearadddata(done) {
            this.showadd = false
            this.baseForm = {}
            this.jgList = []
            this.markerList = []
            this.haveList = []
            this.checkList = []
            this.jwList = []
            done()
        },
        //删除操作
        async showdeletepanduan(id) {
            this.$confirm("此操作将删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(async () => {
                    let data = {}
                    data.id = id
                    var res = await request({
                        url: "/admin/inspection/info/deleteInspection",
                        method: "POST",
                        data: data,
                    })
                    if (res.code == 200) {
                        this.$message({
                            message: "删除成功",
                            type: "success",
                        })
                        this.showadd = false
                        this.getPageDatas()
                    } else {
                        this.$message({
                            message: "删除失败：" + res.message,
                            type: "error",
                        })
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    })
                })
        },

        //初始化地图插件的方法
        mapInit(containerId) {
            this.mapcontainer = new AMap.Map(containerId, {
                resizeEnable: true,
                zoom: 18,
                zooms: [3, 20],
                expandZoomRange: true,
            })
        },
    },
    mounted() {
        this.getPageDatas()
    },
}
</script>

<style lang="less" scoped>
.check {
    border-radius: 4px;
    width: 70%;
    height: 150px;
    border: 1px solid #e8e8e8;
    overflow: auto;
}
// 表格的盒子
.table_card {
    // overflow: hidden;
    // 解决表格无法自适应宽度
    // width: calc(100vw - 500px);
    margin: 0 0 0 0;
    .el-table {
        width: 100%;
        // 表格里的按钮
        .tabBtn {
            margin: 0;
        }
        .tabBtn:nth-child(1) {
            color: #199b5d;
            font-size: 22px;
        }
        .tabBtn:nth-child(2) {
            // color: #ff04ed;
            color:#2e99cf
            // font-size: 25px;
        }
        .tabBtn:nth-child(3) {
            color: #dd3020;
            // font-size: 25px;
        }
        .tabBtn:nth-child(5) {
            color: #e400ff;
            font-size: 22px;
        }
        .tabBtn:nth-child(4) {
            color: #2e99cf;
            // font-size: 25px;
        }
        .active_Btn {
            color: #ff04ed !important;
            // font-size: 25px;
        }
    }
}
</style>
